<template>
    <div class="container p-0">
        <div v-if="isMobile">
			<!-- <div class="p-1">
				<div class="row">
					<div class="col-12 nav-wrapper mg-b-20 tx-13">
						<nav class="nav nav-line tx-medium">
							<a href="#overall-ghs" class="nav-link active" data-toggle="tab">GHS</a>
							<a href="#overall-usd" class="nav-link" data-toggle="tab">USD</a>
						</nav>
					</div>
					<div class="col-12">
						<div class="tab-content">
							<div id="overall-ghs" class="tab-pane fade active show">
								<overall-chart-mobile :portfolio-allocation="allocation.ghs"/>
							</div>
							<div id="overall-usd" class="tab-pane fade">
								<overall-chart-mobile :portfolio-allocation="allocation.usd"/>
							</div>
						</div>
					</div>
				</div>
			</div> -->
		</div>
		<div v-else>
			<div class="row">
				<div v-if="ghs" class="col-md-1 chart-currency">
					<p class="tx-semibold tx-color-03">{{ ghs.options.currency }}</p>
				</div>
				<div class="col-md-9 p-0" id="ghs-chart"></div>
				<div v-if="ghs" class="col-md-2 chart-total"><p>{{ ghs.datasets[0].options.total|toCurrency(ghs.options.currency) }}</p></div>
			</div>
			<div v-if="usd" class="row">
				<div  class="col-md-1 chart-currency">
					<p class="tx-semibold tx-color-03">{{ usd.options.currency }}</p>
				</div>
				<div class="col-md-9 p-0" id="usd-chart"></div>
				<div v-if="usd" class="col-md-2 chart-total"><p>{{ usd.datasets[0].options.total|toCurrency(usd.options.currency) }}</p></div>
			</div>
		</div>
    </div>
</template>

<style scoped>
	.row {
		margin-right: 0px;
		margin-left: 0px;
	}

	svg.frappe-chart.chart {
		height: 90px !important;
	}

	.chart-currency,
	.chart-total {
		padding: 0;
	}

	.chart-currency p {
		text-align: right;
		margin: 1.5rem 0 !important;
	}

	.chart-total p {
		text-align: left;
		font-weight: 700;
		margin: 1.5rem 0 !important;
	}

	@media (max-width: 450px) {
		.chart-currency,
		.chart-total {
			display: none;
		}
	}
</style>

<script>
	import "frappe-charts/dist/frappe-charts.min.css";
	import { Chart } from "frappe-charts/dist/frappe-charts.esm";

	export default {
		mounted() {
			if (!this.isMobile) {
				this.createChart();
			}
		},
		data() {
			return {
				loading: true,
				allocation: this.portfolioAllocation ?? null,
				error: null
			};
		},
		computed: {
			isMobile: function() {
				return this.$store.getters.window_size.width <= 768;
			},
			ghs() {
				const { ghs } = this.portfolioAllocation

				return ghs ? ghs : null
			},
			usd() {
				const { usd } = this.portfolioAllocation

				return usd ? usd : null
			},
		},
		methods: {
			createChart() {
				if (this.ghs) {
					new Chart('#ghs-chart', {
						data: {
							labels: this.ghs.labels,
							datasets: this.ghs.datasets,
						},
						type: this.ghs.type,
						colors: this.ghs.options.colors,
						height: this.ghs.height,
						maxSlices: this.ghs.options.slices,
						barOptions: {
							height: 11,
							depth: 1,
						},
					})
				}

				if (this.usd) {
					new Chart('#usd-chart', {
						data: {
							labels: this.usd.labels,
							datasets: this.usd.datasets,
						},
						type: this.usd.type,
						colors: this.usd.options.colors,
						height: this.usd.height,
						maxSlices: this.usd.options.slices,
						barOptions: {
							height: 11,
							depth: 1,
						},
					})
				}

				this.loading = false
			},
		},
		props: ["portfolioAllocation"]
	};
</script>